import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

type OwnerAssignment =
    | { type: "workstream"; workstreamId: string; ownerId: string | null }
    | { type: "deliverable"; workstreamId: string; deliverableId: string; ownerId: string | null };

export function useAssignOwnersMutation() {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (assignments: OwnerAssignment[]) => {
            const results = await Promise.allSettled(
                assignments.map((a) => {
                    if (a.type === "workstream") {
                        return apiClient.updateWorkstream({
                            params: { projectId: project.id, workstreamId: a.workstreamId },
                            body: { ownerId: a.ownerId },
                        });
                    } else {
                        return apiClient.updateDeliverable({
                            params: {
                                projectId: project.id,
                                workstreamId: a.workstreamId,
                                deliverableId: a.deliverableId,
                            },
                            body: { ownerId: a.ownerId },
                        });
                    }
                })
            );
            await queryClient.refetchQueries({ queryKey: ["project", project.id] });
            const failures = results.filter((r) => r.status === "rejected");
            if (failures.length > 0) {
                throw new Error(`Failed to assign ${failures.length} of ${assignments.length} owners`);
            }
        },
    });
}
